module.exports = __webpack_public_path__ + "static/media/6630.ae2d9af3.jpg";